import { Box, Container, Typography, Card, useTheme } from "@mui/material";
import React from "react";
import Page from "../Page";
import { DomainText } from "../chargeMiles/DomainText";

export default function Refund() {
  const theme = useTheme();

  return (
    <Page title="Refund Policy | ChargeMiles" sx={{ marginTop: { xs: "128px", md: "62px" }, overflow: "hidden", minHeight: '100vh', pb: 10 }}>
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden" 
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 4, md: 6 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" fontWeight={700} gutterBottom>
              Refund & Cancellation Policy
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.85, maxWidth: 600, mx: 'auto' }}>
              We understand that plans change. Review our flexible refund protocols for charging sessions.
            </Typography>
          </Box>

          <Box sx={{ 
            p: { xs: 3, md: 6 },
            '& .MuiTypography-root[variant="p"]': { color: 'text.secondary !important', fontSize: '1rem !important', lineHeight: 1.8 }
          }}>
        <Typography
          variant="p"
          style={{
            textAlign: "start",
            display: "block",
            marginBottom: 30,
          }}
        >
          The service being provided by <DomainText /> Ltd. (aka <DomainText />)
          is for charging of EVs at the charging stations owned and/or operated
          by various CPO’s. The cost of charging a vehicle is collected at the
          beginning as per his need like the amount/KWH and then the charging
          gun is unlocked and in case of any charging issues , the consumer can
          connect to <DomainText /> support with the number displayed on the
          unit and also reach out for support:{" "}
          <a href="mailto:info@chargemiles.ca">info@chargemiles.ca</a>
          {" "}and we would try to resolve the problem in 24 working Hrs. The
          consumer at his own will not use the charging service if he/she finds
          the service not upto the mark or the prices for the services are
          considered high. Once the consumer’s electric vehicle has been charged
          as per the unit meter reading, CPO reserves the right to charge the
          cost of charging from the consumer. 
        </Typography>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
